import { cn } from "@bigpp/ui/lib/utils";

// Three-dot bouncing loader, matching AI Elements' Loader. Small and low
// contrast so it doesn't fight streaming text arriving right after.
export function Loader({ label, className }: { label?: string; className?: string }) {
  return (
    <div
      className={cn(
        "flex items-center gap-1.5 text-xs text-[var(--color-muted-foreground)]",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <span className="flex items-center gap-0.5">
        <span
          className="size-1 rounded-full bg-current animate-loader-bounce"
          style={{ animationDelay: "0ms" }}
        />
        <span
          className="size-1 rounded-full bg-current animate-loader-bounce"
          style={{ animationDelay: "150ms" }}
        />
        <span
          className="size-1 rounded-full bg-current animate-loader-bounce"
          style={{ animationDelay: "300ms" }}
        />
      </span>
      {label && <span>{label}</span>}
    </div>
  );
}
